
import React, { useEffect, useState } from "react";

export const VideoFrame = ({ url,defaultHeight = 300 }) => {
    const [supportsAspect, setSupportsAspect] = useState(false);
  
    useEffect(() => {
      if (CSS.supports("aspect-ratio", "16/9")) {
        setSupportsAspect(true);
      }
    }, []);
  
    const embedUrl = url.replace("/view", "/preview");
  
    return (
      <div
        className="video-wrapper"
        style={
          supportsAspect
            ? { aspectRatio: "16/9", width: "100%" }
            : { width: "100%", height: defaultHeight }
        }
      >
        <iframe
          src={embedUrl}
          allow="autoplay"
          allowFullScreen
          title="Google Drive Video"
          style={{ width: "100%", height: "100%", border: "none",borderRadius:10 }}
        />
      </div>
    );
  };